import $ from 'jquery';
import plugin from '@core/plugins/lib';
import Collapsible from './collapsible';

const ELEMENT_SELECTOR = '[data-collapsible]';
const PLUGIN_NAME = 'Collapsible';

plugin(PLUGIN_NAME, Collapsible);

$(document).ready(() => {
	$(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});



// WEBPACK FOOTER //
// ./project/client/src/core/plugins/jquery__collapsible/plugin--bundled.js